import { render, staticRenderFns } from "./goodsTrack.vue?vue&type=template&id=349e2118&scoped=true"
import script from "./goodsTrack.vue?vue&type=script&lang=js"
export * from "./goodsTrack.vue?vue&type=script&lang=js"
import style0 from "./goodsTrack.vue?vue&type=style&index=0&id=349e2118&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349e2118",
  null
  
)

export default component.exports